import { AssetFromTemplateSkipped, AssetsFromTemplatesResult } from 'models/assetsFromTemplates';
import { AssetTemplate } from 'models/assetTemplate';
import { AssetTemplateListDTO } from 'models/dto/assetTemplateDTO';
import { AssetsFromTemplatesResultDTO } from 'models/dto/assetsFromTemplatesDTO';

export const mapFromAssetTemplates = (dto: AssetTemplateListDTO): AssetTemplate[] =>
  (dto.items ?? []).map((item) => {
    const template = new AssetTemplate();
    template.id = item.id;
    template.name = item.name;
    template.description = item.description;
    template.assetType = item.assetType;
    template.categoryId = item.categoryId;
    template.category = item.category;
    template.categoryDescription = item.categoryDescription;
    template.existingAssetId = item.existingAssetId ?? undefined;
    template.existingAssetName = item.existingAssetName ?? undefined;

    return template;
  });

export const mapFromAssetsFromTemplatesResult = (dto: AssetsFromTemplatesResultDTO): AssetsFromTemplatesResult => {
  const output = new AssetsFromTemplatesResult();
  output.created = (dto.created ?? []).map((item) => ({ templateId: item.templateId, assetId: item.assetId }));
  output.skipped = (dto.skipped ?? []).map((item) => {
    const skipped = new AssetFromTemplateSkipped();
    skipped.templateId = item.templateId;
    skipped.code = item.code ?? '';
    skipped.reason = item.reason ?? '';
    skipped.assetId = item.assetId ?? undefined;
    skipped.assetName = item.assetName ?? undefined;

    return skipped;
  });

  return output;
};
